import intersection from 'lodash-es/intersection';
import union from 'lodash-es/union';
import {SearchUrl} from './partner-search-url';

export enum SelectionType {And, Or}

// A selection property (dropdown menu)
interface Selection {
  id: number;
  // Criteria are and / or connected
  type: SelectionType;
  // The nodes which are currently selected
  activeNodes: number[];
  // The selectabe values (chekcboxes)
  criteria: {
    id: number;
    checked: boolean;
    // The amount of nodes that this criterion would add  
    count: number;
    // All nodes that have this value
    nodeIds: number[];
  }[];
}

// A name for searching
interface Name {
  nid: number;
  name: string;
}

export class SelectionModel {

  selections: Selection[];
  initialNodeAmount: number;
  activeNodeAmount: number;
  searchUrl: SearchUrl;

  constructor (selectionModelElement: HTMLElement, counterElement: HTMLElement, searchUrl: SearchUrl) {  
    // Set Selections
    const jsonList = selectionModelElement.textContent ? selectionModelElement.textContent : '[]';
    this.selections = JSON.parse(jsonList);

    // Set initialNodeAmount
    this.initialNodeAmount = Number(counterElement.dataset.counter);

    this.searchUrl = searchUrl;

    // Update counters
    this.update();
  }


  getActiveNodes(): [number[], boolean] {

    let nodesPerSelection: number[][] = [];
    let hasActiveCriteria: boolean = false;
    for (const selection of this.selections) {
      const activeCriteria = selection.criteria.filter(criterion => criterion.checked == true);
      const nodeLists = activeCriteria.map(criterion => criterion.nodeIds);
      selection.activeNodes = (selection.type == SelectionType.And) ? 
        intersection(...nodeLists) :
        union(...nodeLists);

      if (activeCriteria.length > 0) {;
        hasActiveCriteria = true;
        nodesPerSelection.push(selection.activeNodes);
      }
    }

    const activeNodes = intersection(...nodesPerSelection); 
    return [activeNodes, hasActiveCriteria];
  }




  update() {

    // update criterion count
    for (let selection of this.selections) {
      for (let criterion of selection.criteria) {

        if (!criterion.checked) {
          criterion.checked = true;
          const [hypotheticalActiveNodes, hasActiveCriteria] = this.getActiveNodes();
          criterion.checked = false;

          // if (!hasActiveCriteria) {
          //   criterion.count = criterion.nodeIds.length;
          // } else {
            criterion.count = intersection(criterion.nodeIds, hypotheticalActiveNodes).length;
          // }
        }
      }
    }

    // update activeNodeAmount
    const [activeNodes, hasActiveCriteria]= this.getActiveNodes();
    this.activeNodeAmount = (!hasActiveCriteria) ? 
      this.initialNodeAmount : 
      activeNodes.length;

    // update selection url
    this.searchUrl.selectionUrl = [];
    for (const selection of this.selections) {

      const checkedCriteriaId = selection.criteria
          .filter(criterion => criterion.checked == true)
          .map(criterion => criterion.id);

      if (checkedCriteriaId.length > 0) {
        this.searchUrl.selectionUrl.push(selection.id + '=' + checkedCriteriaId.join(','));
      }
    }
  }


  toggleChecked(elementId: string) {
    for (const selection of this.selections) {
      for (let criterion of selection.criteria) {
        if (criterion.id.toString() == elementId) {
          criterion.checked = criterion.checked ? false : true;
        }
      }
    }

    this.update();
  }

}